// extracted by mini-css-extract-plugin
export default {"wrapper":"Settings_wrapper__Em-H6","container":"Settings_container__VgZM+","footer":"Settings_footer__ZodvG"};